import { coreServices } from '@/mocks/home';
import { Link } from 'react-router-dom';

export default function ServicesSection() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-4">
            核心服务
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            JMTT 为您提供全方位解决方案
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            覆盖数据管理、交易处理、智能营销等多个领域，满足您的各类业务需求
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {coreServices.map((service) => (
            <div
              key={service.id}
              className="p-6 md:p-7 rounded-lg bg-background-50 border border-background-200/70 hover:border-accent-200/70 transition-all duration-300 group cursor-pointer"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-5">
                <i className={`${service.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading font-semibold text-foreground-900 text-base mb-2">
                {service.title}
              </h3>
              <p className="text-foreground-500 text-sm leading-relaxed mb-4">
                {service.description}
              </p>
              <div className="flex flex-wrap gap-2">
                {service.highlights.map((h, idx) => (
                  <span key={idx} className="px-2.5 py-1 rounded-md bg-secondary-100 text-secondary-700 text-xs font-medium">
                    {h}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/categories"
            className="inline-flex items-center gap-2 text-primary-600 hover:text-primary-700 font-medium text-sm transition-colors cursor-pointer"
          >
            查看全部服务
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}